// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:14:41

export default {
  "id": "idle-legend",
  "slug": "idle-legend",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/46843827c1a146689b233df43638e00b-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/46843827c1a146689b233df43638e00b/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Idle Legend",
      "description": "Dive into an exciting world! Fight monsters, gather battle energy, unlock bosses, and defeat them to earn coins. Spend coins on upgrades, skins, and pets. Enjoy vibrant cartoon graphics and exciting quests. Start your adventure today!",
      "instructions": "Move between zones, fight monsters, gather energy, unlock bosses, defeat them, and upgrade your hero.",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "colorful",
        "fantasy",
        "guns",
        "monster",
        "timekiller"
      ]
    },
    "zh-CN": {
      "title": "悠闲传说",
      "description": "深入一个精彩的世界！与怪物战斗，收集战斗能量，解锁Boss，击败他们来赚取金币。用金币购买升级、皮肤和宠物。享受鲜艳的卡通图形和激动人心的任务。今日开始你的冒险之旅！",
      "instructions": "在区域间移动，与怪物战斗，收集能量，解锁Boss，击败他们，并升级你的英雄。",
      "genres": [
        "冒险"
      ],
      "tags": [
        "多彩",
        "幻想",
        "枪械",
        "怪物",
        "时间杀手"
      ]
    },
    "zh-TW": {
      "title": "閒逸傳說",
      "description": "跳進一個刺激的世界！與怪物戰鬥、聚集戰鬥能量、解鎖boss，並擊敗他們來獲得金幣。用金幣購買升級、外觀和寵物。享受豐富的卡通圖像和刺激的任務。今日開啟你的冒險吧！",
      "instructions": "在區域間移動，戰鬥怪物，收集能量，解鎖頭目，擊敗他們，並升級你的英雄。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "豐富多彩",
        "幻想",
        "槍械",
        "怪物",
        "時間殺手"
      ]
    },
    "zh-HK": {
      "title": "閒逸傳說",
      "description": "投入一個令人興奮的世界！戰鬥怪物，收集戰鬥能量，解鎖大頭目，並擊敗他們來獲得金幣。用金幣購買升級、外觀和寵物。享受豐富的卡通圖像和刺激的任務。今天開始你的冒險吧！",
      "instructions": "之間移動、戰鬥怪物、收集能量、解鎖大頭目、擊敗他們並升級你的英雄。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "色彩豐富",
        "奇幻",
        "槍械",
        "怪物",
        "時間消磨者"
      ]
    },
    "ja": {
      "title": "アイドル伝説",
      "description": "興奮する世界に飛び込みましょう！モンスターと戦い、バトルエネルギーを集め、ボスを解放して討伐し、コインを手に入れましょう。コインを使ってアップグレード、スキン、ペットを購入してください。鮮やかなカートゥーングラフィックと興味深いクエストを楽しみましょう。今日からあなたの冒険を始めましょう！",
      "instructions": "ゾーンを移動し、モンスターと戦い、エネルギーを集め、ボスを解放し、彼らを倒し、ヒーローを強化してください。",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "カラフル",
        "ファンタジー",
        "銃",
        "モンスター",
        "タイムキラー"
      ]
    },
    "ko": {
      "title": "idle 레전드",
      "description": "재미있는 세상에 뛰어들어보세요! 몬스터를 싸우고 전투 에너지를 모으고, 보스를 해금하고 그들을 꺼내치면 동전을 얻습니다. 동전을 업그레이드, 스킨, 펫에 사용하세요. 생동감 넘치는 카툰 그래픽과 흥미진진한 퀘스트를 즐겨보세요. 오늘 하루 만에 모험을 시작하세요!",
      "instructions": "지역 간 이동, 몬스터와 싸우기, 에너지 모으기, 보스 해금, 이길기, 그리고 영웅을 업그레이드하세요.",
      "genres": [
        "모험"
      ],
      "tags": [
        "색다양한",
        "판타지",
        "총",
        "몬스터",
        "시간소모자"
      ]
    },
    "fr": {
      "title": "Légende Paresseuse",
      "description": "Plongez dans un monde passionnant ! Combattez les monstres, récoltez de l'énergie de bataille, débloquez les chefs et les vainquez pour gagner des pièces. Dépensez vos pièces en améliorations, skins et pets. Profitez des graphismes cartoon colorés et des quêtes captivantes. Commencez votre aventure aujourd'hui !",
      "instructions": "Se déplacer entre les zones, combattre les monstres, rassembler de l'énergie, déverrouiller les boss, les battre et améliorer votre héros.",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "coloré",
        "fantastique",
        "armes",
        "monstre",
        "tue-le temps"
      ]
    }
  }
};
